import React, { useState, useEffect } from "react";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import DataTable from "../../../components/Content/DataTable";

// Date & Time
import moment from "moment";

// Utils
import { getAlert, getByDocId } from "../../../../utils/SamuiUtils";
// import { formatThaiDateUi } from "../../../../utils/DateUtils";

// Components Date Filter
import DateFilterTable from "../../../components/Content/DateFilterTable";

function Main({
  masterList,
  statusColours,
  name,
  onPageInsert,
  onRowSelected,
  getReport,
  setStartDate,
  setEndDate,
  startDate,
  endDate,
  fetchRealtime,
}) {
  const [dataMasterList, setDataMasterList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(12);
  const [, setCountWaitApprove] = useState(0);
  const [, setCountApprove] = useState(0);
  const [, setCountCancel] = useState(0);

  // ใช้สำหรับค้นหาเอกสาร
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredItems, setFilteredItems] = useState([]);

  // Filter by date & Sort by field
  const [sortOrder, setSortOrder] = useState("");
  const [sortField, setSortField] = useState("");
  const [selectedDateType, setSelectedDateType] = useState("1");
  const [allDates, setAllDates] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [masterList]);

  // Optimized: ใช้ useMemo แทน useEffect เพื่อลด re-render
  useEffect(() => {
    setCurrentPage(1);
    filterItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm, dataMasterList]);

  const initialize = async () => {
    try {
      if (masterList && masterList.length > 0) {
        // สร้าง mapping ของสถานะจาก statusColours
        const statusMap = {};
        if (statusColours && statusColours.length > 0) {
          statusColours.forEach(status => {
            statusMap[status.DocSetStatus] = {
              name: status.DocSetStaus_Name,
              color: status.DocSetColour
            };
          });
        }
        console.log("Status Map:", statusMap);
        console.log("Master List Sample:", masterList[0]);

        // เพิ่ม DocStatus_Name และ DocStatus_Colour ให้กับแต่ละ item
        const enrichedMasterList = masterList.map(item => {
          const status = statusMap[item.Doc_Status];
          return {
            ...item,
            DocStatus_Name: status ? status.name : "-",
            DocStatus_Colour: status ? status.color : "#cccccc"
          };
        });
        console.log("Enriched List Sample:", enrichedMasterList[0]);

        // คำนวณ NetTotal จาก CR_D
        const enrichedWithNetTotal = await Promise.all(
          enrichedMasterList.map(async (item) => {
            try {
              const details = await getByDocId("CR_D", item.Doc_Id);
              // รวม Item_Total จาก CR_D
              const sum = details.reduce((acc, d) => acc + (parseFloat(d.Item_Total) || 0), 0);

              // คำนวณส่วนลด
              const discountValue = parseFloat(item.Discount_Value) || 0;
              const discountType = item.Discount_Value_Type;
              let discount = 0;

              if (discountType === 1 || discountType === "1") {
                // Type 1: หักเป็นบาท
                discount = discountValue;
              } else if (discountType === 2 || discountType === "2") {
                // Type 2: หักเป็นเปอร์เซ็นต์
                discount = (discountValue / 100) * sum;
              }

              // หักส่วนลดจาก sum
              const afterDiscount = sum - discount;

              // เช็ค IsVat ใน CR_H ถ้าเป็น 1 ให้คูณ 1.07
              const netTotal = item.IsVat === 1 ? afterDiscount * 1.07 : afterDiscount;

              return { ...item, NetTotal: netTotal };
            } catch (error) {
              console.error(`Error calculating NetTotal for Doc_Id ${item.Doc_Id}:`, error);
              return { ...item, NetTotal: 0 };
            }
          })
        );

        setDataMasterList(enrichedWithNetTotal);

        // นับข้อมูลสถานะ
        let statusCounts = {
          ลดหนี้: 0,
          ยกเลิก: 0,
        };

        // Optimized: ใช้ reduce แทน forEach (เร็วกว่า)
        statusCounts = enrichedWithNetTotal.reduce((acc, data) => {
          if (data.DocStatus_Name) {
            acc[data.DocStatus_Name] = (acc[data.DocStatus_Name] || 0) + 1;
          }
          return acc;
        }, statusCounts);

        setCountWaitApprove(statusCounts["ลดหนี้"]);
        setCountApprove(0);
        setCountCancel(statusCounts["ยกเลิก"]);
        setCurrentPage(1); // รีเซ็ตหน้าเมื่อมีข้อมูลใหม่
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const filterItems = () => {
    if (searchTerm === "") {
      setFilteredItems(dataMasterList);
    } else {
      const lowercasedSearchTerm = searchTerm.toLowerCase();
      const filtered = dataMasterList.filter((item) =>
        Object.values(item).some(
          (value) =>
            typeof value === "string" &&
            value.toLowerCase().includes(lowercasedSearchTerm)
        )
      );
      setFilteredItems(filtered);
    }
  };

  //ค้นหาวันที่และเลขเอกสาร
  const handleSearch = async () => {
    setIsLoading(true);
    try {
      // เรียก fetchRealtime โดยส่งวันที่ BE ปัจจุบัน ป้องกันค่า stale
      await fetchRealtime(false, allDates, startDate, endDate);
      // ข้อมูลจาก server จะมาที่ masterList แล้วจะ set ให้ dataMasterList ผ่าน useEffect
    } finally {
      setIsLoading(false);
    }
  };

  // Clear search and date filters
  const handleClear = () => {
    setSearchTerm("");
    setStartDate(moment().startOf("month").add(543, "year").format("YYYY-MM-DD"));
    setEndDate(moment().endOf("month").add(543, "year").format("YYYY-MM-DD"));
    setSelectedDateType("1");
    setAllDates(false);
    setFilteredItems(dataMasterList);
    setSortField("");
    setSortOrder("desc");
  };

  // Sort เรียงลำดับ asc to desc
  const handleSort = () => {
    if (!sortField) return;
    // การเรียงจะขึ้นอยู่กับค่าของ newSortOrder
    const newSortOrder = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(newSortOrder);

    const sortedItems = [...filteredItems].sort((a, b) => {
      // ถ้า newSortOrder เป็น 'asc' จะเรียงจากน้อยไปมาก
      if (newSortOrder === "asc") {
        return a[sortField].localeCompare(b[sortField]);
      } else {
        // ถ้าเป็น 'desc' จะเรียงจากมากไปน้อย
        return b[sortField].localeCompare(a[sortField]);
      }
    });
    setFilteredItems(sortedItems);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <>
      <div className="page-header d-flex justify-content-between align-items-center mb-0">
        <Breadcrumbs
          page={name}
          items={[
            { name: "บัญชี", url: "/credit-note" },
            { name: name, url: "/credit-note" },
          ]}
        />
      </div>
      <div
        className="row hidden-scrollbar"
        style={{ maxHeight: "80vh", overflowY: "auto", overflowX: "visible" }}
      >
        <div className="col-12">
          <div
            className="p-3 rounded-3 my-2 shadow-lg"
            style={{ backgroundColor: "#ffff", position: "relative", zIndex: 1 }}
          >
            <div className="row mb-2">
              <div className="col-3">
                <div className="navbar-form nav-search">
                  <div className="input-group">
                    <input
                      type="text"
                      placeholder="ค้นหาเอกสาร..."
                      className="form-control"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <span className="input-group-text">
                      <i className="fas fa-search"></i>
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-7 d-flex align-items-center" style={{ gap: '12px' }}>
                <DateFilterTable
                  startDate={startDate}
                  endDate={endDate}
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                  selectedDateType={selectedDateType}
                  setSelectedDateType={setSelectedDateType}
                  handleSearch={handleSearch}
                  allDates={allDates}
                  setAllDates={setAllDates}
                />
              </div>
              <div className="col-2 d-flex justify-content-end">
                <button
                  onClick={onPageInsert}
                  className="btn btn-warning text-white ms-2"
                  type="button"
                >
                  สร้าง{name} <i className="fa fa-plus"></i>
                </button>
              </div>
            </div>
            <div
              className="p-1 px-3 rounded-3 shadow-sm"
              style={{ backgroundColor: "#f5f7fd" }}
            >
              <div className="row mb-2">
                <small
                  className="d-block p-1 fw-bold"
                  style={{
                    borderLeft: "5px solid #EF6C00",
                    borderRadius: "3px",
                  }}
                >
                  เรียงลำดับตาม
                </small>

                <div className="col-1 d-flex justify-content-between">
                  <div className="radio-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      checked={sortField === "Doc_No"}
                      onChange={() => setSortField("Doc_No")}
                    />
                    <label className="text-black">เลขที่เอกสาร</label>
                  </div>
                </div>
                <div className="col-1 d-flex justify-content-between">
                  <div className="radio-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      checked={sortField === "Doc_Date"}
                      onChange={() => setSortField("Doc_Date")}
                    />
                    <label className="text-black">วันที่เอกสาร</label>
                  </div>
                </div>
                <div className="col-1 d-flex justify-content-between">
                  <div className="radio-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      checked={sortField === "Doc_INV_No"}
                      onChange={() => setSortField("Doc_INV_No")}
                    />
                    <label className="text-black">เลขที่ใบวางบิล</label>
                  </div>
                </div>
                <div className="col-1 d-flex justify-content-between">
                  <button
                    className="btn btn-outline-secondary"
                    onClick={handleSort}
                    style={{
                      cursor: "pointer",
                      color: "black",
                      backgroundColor: "transparent",
                    }}
                  >
                    <i
                      className={`fas fa-arrow-${sortOrder === "asc" ? "up" : "down"
                        }`}
                    ></i>{" "}
                    Sort
                  </button>
                </div>
                <div className="col-8 d-flex justify-content-end">
                  <button
                    onClick={handleClear}
                    className="btn btn-danger text-white"
                    type="button"
                    style={{ padding: "0.9rem" }}
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </div>
          {isLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-[#EF6C00]" role="status" style={{ width: '3rem', height: '3rem' }}>
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-3 text-muted">กำลังโหลดข้อมูล...</p>
            </div>
          ) : (
            <DataTable
              currentItems={currentItems}
              onRowSelected={onRowSelected}
              currentPage={currentPage}
              handlePageChange={handlePageChange}
              dataMasterList={filteredItems}
              itemsPerPage={itemsPerPage}
              fieldMappings={{
                no: "Doc_No",
                rev: "Doc_Rev",
                typeName: "DocType_Name",
                statusName: "DocStatus_Name",
                statusColor: "DocStatus_Colour",
                date: "Doc_Date",
                arCode: "AR_Code",
                arName: "AR_Name",
                dueDate: "Doc_DueDate",
                netTotal: "NetTotal",
                createdBy: "Created_By_Name",
                updatedBy: "Update_By_Name",
                docInvNo: "Doc_INV_No",
              }}
              getReport={(docNo) => getReport("CR", docNo)}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default Main;
